import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from '@/pages/Login'
import Projects from '@/pages/Projects'
import Employees from '@/pages/Employees'
import TaskReports from '@/pages/TaskReports'
import PrivatePage from './components/PrivatePage'
import Setup from './pages/Setup'
import Clients from '@/pages/Clients'
import PublicPage from './components/PublicPage'
import Settings from './pages/Settings'
import DashboardLayout from '@/layouts/DashboardLayout'
import Home from './pages/Home'
import NotFound from '@/layouts/NotFound'
import UserManagement from './pages/UserManagement'
import AcceptInvite from './pages/AcceptInvite'
import ResetPassword from './pages/ResetPassword'
import Profile from './pages/Profile'

import Sheet from '@/pages/Sheet'
import DescriptionAnalysis from './pages/DescriptionAnalysis'
import AlertDashboard from './pages/AlertDashboard'
import Holidays from './pages/Holidays'
import WeeklyResourcePlanning from './pages/WeeklyResourcePlanning'
import Health from './pages/Health'
import Vendors from './pages/Vendors'
import PublicLeaveRequest from './pages/PublicLeaveRequest'
import Widgets from './pages/Widgets'
import { IS_PRODUCTION } from './constant'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicPage />}>
          <Route path='/login' element={<Login />} />
          <Route path='/home' element={<Home />} />
          <Route path='/accept-invite' element={<AcceptInvite />} />
          <Route path='/reset-password' element={<ResetPassword />} />
        </Route>
        {/* Intentionally outside both PublicPage (which redirects logged-in
            users away) and PrivatePage (which requires a token) — this page
            is meant to be shared as a plain link and work either way. */}
        <Route path='/leave-request' element={<PublicLeaveRequest />} />
        <Route path='*' element={<NotFound />} />
        <Route element={<PrivatePage />}>
          <Route path='/' element={<DashboardLayout />}>
            <Route path='/' element={<Projects />} />
            <Route path='/employees' element={<Employees />} />
            <Route path='/employees/pending' element={<Employees />} />
            <Route path='/employees/teams' element={<Employees />} />
            <Route path='/employees/skills' element={<Employees />} />
            <Route path='/clients' element={<Clients />} />
            <Route path='/timesheet' element={<TaskReports />} />
            <Route path='/projects/setup' element={<Setup />} />
            <Route path='/settings/company' element={<Settings />} />
            <Route path='/user-management' element={<UserManagement />} />
            <Route path='/profile' element={<Profile />} />
            {IS_PRODUCTION && <Route path='/sheet' element={<Sheet />} />}
            {IS_PRODUCTION && <Route path='/health' element={<Health />} />}
            <Route
              path='/timesheet/analysis'
              element={<DescriptionAnalysis />}
            />
            <Route path='/timesheet/alert' element={<AlertDashboard />} />
            <Route path='/holidays' element={<Holidays />} />
            <Route path='/widgets' element={<Widgets />} />
            <Route
              path='/weekly-planning'
              element={<WeeklyResourcePlanning />}
            />
            <Route path='/vendors' element={<Vendors />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
